<template>
  <div class="main-container" v-if="label">
    <h1 class="subtitle">{{label.buttons.users}}</h1>
    <p style="margin-bottom: 1rem;">{{label.texts.totalUsers}} : {{nbTotal}}</p>

    <div class="filters">
      <div class="fields date-form">
        <div class="date-form-input">
          <label>{{label.texts.inscriptionDate}} - {{label.texts.from}} : </label>
          <VueDatePicker
            v-model="createdFrom"
            @update:model-value="reloadFilters()"
            input-class="input"
            auto format="dd-MM-yyyy"
            timezone="Europe/Brussels"
            locale="fr"
            :selectText="label.buttons.ok"
            :cancelText="label.buttons.cancel"
            :enableTimePicker="false"
            weekStart='1'
            :hideInputIcon="true"
            :auto-apply="true"
          >
          </VueDatePicker>
        </div>
        <div class="date-form-input">
          <label>{{label.texts.to}} : </label>
          <VueDatePicker
            v-model="createdTo"
            @update:model-value="reloadFilters()"
            input-class="input"
            auto format="dd-MM-yyyy"
            timezone="Europe/Brussels"
            locale="fr"
            :selectText="label.buttons.ok"
            :cancelText="label.buttons.cancel"
            :enableTimePicker="false"
            :weekStart='1'
            :hideInputIcon="true"
            :auto-apply="true"
          >
          </VueDatePicker>
        </div>
      </div>

      <div class="fields">
        <div class="input-form">
          <label>{{label.texts.user}} : </label>
          <input type="text" maxlength="500" class="input input-medium" v-model="userInput" @input="reloadFilters()">
        </div>
      </div>

      <button
      id="reset-filters-btn"
        @click="resetFilters()"
        class="button is-outlined is-primary has-tooltip-top has-tooltip-multiline"
        style="max-width: 100%; white-space: normal; height: auto;">
        Réinitialiser les filtres
      </button>
    </div>

    <div>
      <!-- Table -->
      <div class="table-container">
        <table class="table is-hoverable">
          <thead>
            <tr>
          
              <th>{{label.texts.mail}}</th>
              <th>{{label.texts.inscriptionDate}}</th>
              <th>{{label.texts.accessPoints}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loadingData"><td class="has-text-centered" colspan="20">{{label.texts.loading}} ...</td></tr>
            <tr v-else-if="nbFiltered == 0"><td class="has-text-centered" colspan="20">{{label.texts.noData}}</td></tr>
            <tr v-else v-for="client in clients" v-bind:key="client.id">
              
              <td>{{client.email}}</td>
              <td>{{dateSimple(client.createdDate)}}</td>
              <td>{{client.clipod.length}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="horizontal-wrapper">
        <div class="field is-grouped">
          <div class="control">
            <button
              :disabled="nbFiltered == 0"
              class="button is-outlined is-info is-small"
              @click="downloadCsv()"
            >
              {{label.buttons.download}}
            </button>
          </div>
          <div class="control">
            {{label.texts.result}} : {{nbFiltered}}
          </div>
        </div>
        <div class="field is-grouped">
          <div class="control">
            <button
              :disabled="indexPage <= 0"
              class="button is-small"
              @click="indexPage--">{{label.buttons.previous}}</button>
          </div>
          <div class="control"><span class="is-size-7"><strong>{{label.texts.page}} {{indexPage+1}}</strong></span></div>
          <div class="control">
            <button
              :disabled="lastPage"
              class="button is-small"
              @click="indexPage++">{{label.buttons.next}}</button>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import  VueDatePicker  from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { AdminService } from '../../services'

export default {
  components: {
    VueDatePicker,
  },
  data() {
    return {
      clients: [],
      indexPage: 0,
      lastPage: true,
      nbTotal: 0,
      nbFiltered: 0,
      loadingData: true,
      userInput: "",
      userInactive: false,
      createdFrom: "",
      createdTo: "",
      activityFrom: "",
      activityTo: "",
      printData: [],

    }
  },
  computed: {
    ...mapState({ user: state => state.account.user }),
    ...mapState({ label: state => state.labels.admin }),
    filterData() {
      let filters = {}
      if (this.createdFrom) {
        filters.createdFrom = moment(this.createdFrom).format()
      }

      if(this.createdTo) {
        filters.createdTo = moment(this.createdTo).add(1, 'day').format()
      }

      if (this.activityFrom && this.activityTo) {
        filters.activityFrom = this.activityFrom
        filters.activityTo = moment(this.activityTo).add(1, 'day').format()
      }

      if (this.userInput) {
        filters.user = this.userInput
      }

      if (this.userInactive) {
        filters.userInactive = this.userInactive
      }

      return filters
    }
  },
  methods: {
    ...mapActions("labels", ["getLabel"]),
    resetFilters() {
      this.userInput = ""
      this.createdFrom = ""
      this.createdTo = ""
      this.reloadFilters()
    },
    downloadCsv() {
      if (!this.printData || this.printData.length === 0) return
      const headers = ["email", "createdDate", "nbHeadpoints"]
      const delimiter = ';'
      const escape = (val) => {
        if (val === null || val === undefined) return ''
        const s = String(val)
        if (s.includes('"') || s.includes(delimiter) || s.includes('\n')) {
          return '"' + s.replace(/"/g, '""') + '"'
        }
        return s
      }

      const rows = this.printData.map(row => headers.map(h => escape(row[h] ?? '')).join(delimiter))
      const csvContent = [headers.join(delimiter), ...rows].join('\r\n')
      // Add UTF-8 BOM so Excel (FR) detects UTF-8 and parses correctly
      const bom = '\uFEFF'
      const blob = new Blob([bom + csvContent], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.setAttribute('href', url)
      const fileName = 'admin_clients.csv'
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    nameToString(firstName, lastName) {
      if(firstName && lastName)
        return firstName + " " + lastName
      if(firstName)
        return firstName
      if(lastName)
        return lastName
      return "-"
    },
    adminListClients(index = 0, filters = {}, number = 10) {
      AdminService.adminListClients(
        this.user._id,
        index,
        number,
        filters
      )
      .then(clients => {
        // Not admin
        if (!clients) this.$router.push({ path: "/", query: { adminError: true }}, () => {})
        else {
          this.loadingData = false
          this.clients = clients.clients
          this.lastPage = clients.lastPage
          this.nbPages = clients.nbPages
          this.nbTotal = clients.nbTotal
          this.nbFiltered = clients.nbFiltered

          this.printData = clients.clients.map(client => {
            let clientForDownload = {
              email: client.email,
              createdDate: client.createdDate ? moment(client.createdDate).format("DD-MM-YYYY") : ""
            }
            return { ...clientForDownload, nbHeadpoints: client.clipod.length }
          })
        }
      })
    },
    reloadFilters() {
      this.adminListClients(0, this.filterData)
    },
    dateSimple(date) {
      return moment(date).format("DD-MM-YYYY")
    },
    dateTime(date) {
      return moment(date).format("DD-MM-YYYY HH:mm")
    }
  },
  created() {
    this.adminListClients()
    this.getLabel({ view: 'admin' })
  },
  watch: {
    indexPage(newIndex) {
      this.loadingData = true
      this.adminListClients(newIndex, this.filterData)
    }
  }
}
</script>

<style lang="scss" scoped>
.table-container {
  margin-top: 30px;
}

.horizontal-wrapper {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.filters {
  & > :not(:last-child) {
    margin-bottom: 1rem;
  }
}

.date-form {
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  & > :not(:last-child) {
    margin-right: 10px;
  }
}
.date-form-input,
.input-form {
  display: flex;
  align-items: center;

  & > :not(:last-child) {
    margin-right: 10px;
  }
}

.input-small {
  width: 100px !important;
}

.input-medium {
  width: 200px !important;
}

.input-large {
  width: 300px !important;
}

.dp__main {
  width: 200px !important;
}

</style>